module.exports = __webpack_public_path__ + "img/user-01.244e87ad.png";